;(() => {
  const KEY = 'rv:products'
  const MAX = 20
  const toNum = (v) => (typeof v === 'number' ? v : Number(v))

  function writeFrom(el) {
    if (!el || el.dataset.rvWritten === '1') return // prevent double-writes this view
    const id = toNum(el.dataset.id)
    const handle = el.dataset.handle
    if (!id || !handle) return

    try {
      let list = JSON.parse(localStorage.getItem(KEY) || '[]') || []
      list = list
        .map((p) => p && { id: toNum(p.id), handle: p.handle })
        .filter((p) => p && p.id !== id) // de-dupe by id
      list.unshift({ id, handle }) // most-recent first
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)))
      el.dataset.rvWritten = '1'
    } catch (e) {}
  }

  function scan() {
    writeFrom(document.getElementById('rv-product'))
  }

  // Normal loads + bfcache restores
  document.addEventListener('DOMContentLoaded', scan, { once: true })
  window.addEventListener('pageshow', scan)

  // Theme Editor re-renders
  document.addEventListener('shopify:section:load', scan)

  // PJAX/Turbo-like DOM swaps
  const obs = new MutationObserver(scan)
  obs.observe(document.documentElement, { childList: true, subtree: true })
})()
